export const HOLIDAY_INITIAL_STATE={
    holidayName: "",
    holidayDate: "",
    holidayType: ""
}

export const HOLIDAY_TYPE = [
    {
        "id":"National",
        "name":"National"
    },
    {
        "id":"Non-National",
        "name":"Non-National"
    }
]